// src/lib/useDpc6List.ts
// 疾患深掘りタブ サイドバー の DiseaseSelector 用 hook。
// /api/query/dpc6_list?asOf=YYYY-MM-DD を呼んで 直近 12 ヶ月の出現件数つき
// 疾患マスタ (~515 件) を取得。
// 医師は DPC コード (6桁数字) を覚えていないため、 datalist 候補に「疾患名」を出して
// 疾患名で検索できることが目的。
import { useQuery } from "@tanstack/react-query";
import { useFilters } from "../store";
import { diseasePeriod } from "./useDiseaseRanking";
import type { Dpc6ListResponse } from "@shared/api";
import { GP_MODE_HEADER } from "./gpMode";

export function useDpc6List() {
  const f = useFilters();
  // diseasePeriod は asOfMonth の月末 (YYYY-MM-DD) を dateTo として返す。
  // dpc6_list の asOf も同じ「対象月の月末」 を使い、 直近 12 ヶ月の出現件数を揃える。
  const { dateTo } = diseasePeriod(f.asOfMonth, f.dpcfy, f.diseaseAutoPeriod);
  return useQuery({
    queryKey: ["dpc6_list", dateTo],
    queryFn: async () => {
      const r = await fetch(`/api/query/dpc6_list?asOf=${dateTo}`, {
        credentials: "include",
        headers: { ...GP_MODE_HEADER },
      });
      if (!r.ok) throw new Error(`dpc6_list ${r.status}`);
      return r.json() as Promise<Dpc6ListResponse>;
    },
    staleTime: 5 * 60_000,
  });
}
